



































import Vue from 'vue';

export default Vue.extend({
  name: 'Accordion',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    isAccordion: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    isOpen() {
      this.toggle = this.isOpen;
    },
  },
  methods: {
    start(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    end(el) {
      el.style.height = '0px';
    },
  },
  data() {
    return {
      toggle: this.isOpen,
    };
  },
});
